import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { AspectRatioContainerComponent } from './aspect-ratio-container.component';

export const ngxAspectRatioContainerModule = angular.module('ngxAspectRatioContainerModule', [])
	.directive('ngxAspectRatioContainer', downgradeComponent({ component: AspectRatioContainerComponent }))
	.name;
